import { Component, OnInit, EventEmitter } from '@angular/core';
import { HttpService, SessionService, MessageService, TableColumns, TableConfiguration, params, LocalStorageService, MenuBreadCrumb } from 'brainloper-ui';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { MemosDetailComponent } from './memos-detail/memos-detail.component';
import { Memorandum } from 'src/app/models/human-resources/memorandum';

@Component({
    selector: 'app-memos',
    templateUrl: './memos.component.html',
    styleUrls: ['./memos.component.scss'],
    standalone: false
})
export class MemosComponent implements OnInit {

  public urlGetMemorandos: string = `${EndpointDictionary.Memorandum.MEMORANDUM_TABLE}`;
  private urlDeleteMemorandos: string = `${EndpointDictionary.Memorandum.CRUD_MEMORANDUM_DATA}`;

  public titleMemorandos: string = screen.width<500?'':'Memorandos'
  public recargarTablaMemorandos = new EventEmitter<any>()
  public configurationMemorandos: TableConfiguration = {
    edit: false,
    add: true,
    delete: false,
    selectable: false,
    addPer: true,
    editPer: false,
    primaryKey: 'id',
    view:true
  }

  public columnasMemorandos: TableColumns<Memorandum>[] = [
    {
      ID: 'user',
      label: 'Usuario',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'userName',
      label: 'Nombre',
      type: 'string',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'date',
      label: 'Fecha',
      type: 'fecha',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'string',
      style: {
        textAlign: 'center',
        movil:'movil'
      },
    },
    {
      ID: 'generatedByName',
      label: 'Generado por',
      type: 'string',
      style: {
        textAlign: 'center',
        movil:'no-movil'
      },
    }
  ]

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Memorandos",
    current:true
  }]

  constructor(
    private session: SessionService,
    public dialog: MatDialog,
    private deleteItem: DeleteGenericService,
  ) { }

  ngOnInit(): void {
  }

  agregarMemorandos($event) {

    this.session.setData('redireccion', 'nuevo')

    this.dialog.open(MemosDetailComponent, {
      width:'80%',
      data: ''

    }).afterClosed().subscribe(res=>{
      this.recargarTablaMemorandos.emit()
    })
  }

  editarMemorandos($event) {
    //console.log($event)
  }

  async eliminarMemorandos($event: Memorandum[]) {
    //console.log($event)
    let res =  await this.deleteItem.deleteD($event, this.urlDeleteMemorandos, "id", "Memorando", "Memorandos")
          this.recargarTablaMemorandos.emit()

  }

  seleccionadosMemorandos($event) {
    //console.log($event)
  }

  viewMemorandum($event:Memorandum[]) {

    this.session.setData('redireccion', 'visualizar')

    this.dialog.open(MemosDetailComponent, {
      width:'80%',
      data: $event[0]

    })
  }


}
